
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import giftBoxImg from "resources/img/puffu/giftBox.svg";
import colorQrImg from "resources/img/puffu/colorQr.svg";
import puffuIcon from "resources/img/puffu/puffuIconsvg.svg";

import style from "./PaymentLanding.module.css";
import Inline from "layouts/container/Inline";
import Container from "layouts/container/Container";

function PaymentLanding(props) {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [data, setData] = useState();


    useEffect(() => {
        if (location.state) {
            setData(location.state.data);
        }
    }, [location])
    const appDownClick = () => {
        const iOSAppUrlScheme = "puffuios://qrscanner"; // 앱 스킴 (QR 스캔을 위한 스킴)
        // const appStoreUrl = "https://apps.apple.com/kr/app/puffu/id6504068927"; // 앱스토어 URL, YOUR_APP_ID를 실제 앱의 ID로 대체해야 합니다.
        
        // iOS 앱 스킴 호출 (설치된 앱 실행 시도)
        window.location.href = iOSAppUrlScheme;
    
        // 일정 시간 후 (예: 1초), 만약 앱이 설치되지 않았다면 앱스토어로 리다이렉트
        setTimeout(() => {
            // 앱이 설치되지 않은 경우 앱스토어로 이동
            // window.location.href = appStoreUrl;
        }, 1000); // 1초 후 앱스토어로 리다이렉트 시도
    }
    const paymentClick = () => {
        navigate("/memberAccess", {state: {paymentData: data, type : "payment", storeCode: data.storeCode}})
    }


    return (
        <Container height={"80vh"}>
            <VerticalFlex gap={30}>
                <FlexChild />
                <FlexChild height={"max-content"}>
                    <img src={puffuIcon} />
                </FlexChild>
                <FlexChild height={"max-content"}>
                    <P size={"5vw"} weight={800}>결제 방법을 선택해주세요!</P>
                </FlexChild>
                <FlexChild>
                    <VerticalFlex gap={10}>
                        {/* <FlexChild>
                            <div className={style.boxArea} onClick={appDownClick}>
                                <HorizontalFlex>
                                    <FlexChild width={"40%"}>
                                        <img src={giftBoxImg} width={"50%"} />
                                    </FlexChild>
                                    <FlexChild>
                                        <VerticalFlex flexStart>
                                            <FlexChild>
                                                <P size={"5vw"} weight={800}>APP 결제</P>
                                            </FlexChild>
                                            <FlexChild>
                                                <P size={"4.2vw"} weight={600}>APP 다운로드 후</P>
                                            </FlexChild>
                                            <FlexChild>
                                                <Inline>
                                                    <P size={"4.2vw"} weight={700} color={"var(--point-color)"}>혜택받고 </P>
                                                    <P size={"4.2vw"} weight={600}>결제하기</P>
                                                </Inline>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                </HorizontalFlex>
                            </div>
                        </FlexChild> */}
                        <FlexChild>
                            <div className={style.boxArea} onClick={paymentClick}>
                                <HorizontalFlex>
                                    <FlexChild width={"40%"}>
                                        <img src={colorQrImg} width={"50%"} />
                                    </FlexChild>
                                    <FlexChild>
                                        <VerticalFlex flexStart>
                                            <FlexChild>
                                                <P size={"5vw"} weight={800}>즉시 결제</P>
                                            </FlexChild>
                                            <FlexChild>
                                                <P size={"4.2vw"} weight={600}>본인인증 후</P>
                                            </FlexChild>
                                            <FlexChild>
                                                <Inline>
                                                    <P size={"4.2vw"} weight={700} color={"var(--point-color)"}>간편하게 </P>
                                                    <P size={"4.2vw"} weight={600}>결제하기</P>
                                                </Inline>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                </HorizontalFlex>
                            </div>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
                <FlexChild />
            </VerticalFlex>
        </Container>
    );
}

export default PaymentLanding;